<div class="barcode justify-content" style="position: relative; height: 100%">
  <div
    *ngIf="reader"
    style="
      margin: 0;
      position: relative;
      top: 50%;
      left: 0px;
      transform: translate(0, -50%);
      right: 0px;
    "
  >
    <span class="id">{{ ReaderLabel }} Nr. {{ reader.id }}</span
    ><br />
    <span class="title">{{ reader.name }} {{ reader.forename }}</span>

    <br />
    <div class="justify-content">
      <div>
        <svg #barcode></svg><br />
        <span class="library">{{ reader.library.label }}</span>
      </div>
    </div>
  </div>
</div>
